import React, { useEffect } from 'react';

const ScrollToTopWrapper = ({ children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <>{children}</>;
};

export default ScrollToTopWrapper;
